var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1500,
    height: 1500,
    viewBox: "0 0 1500 1500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #000;\n        stroke-width: 1px;\n        stroke-dasharray: 4 2;\n        fill: url(#linear-gradient);\n        filter: url(#filter);\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #505050;\n        stroke-width: 119.3px;\n        opacity: 0.75;\n        filter: url(#filter-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 750.5,
    y1: 1235,
    x2: 750.5,
    y2: 266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter",
    x: 266,
    y: 266,
    width: 969,
    height: 969,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feImage", {
    preserveAspectRatio: "none",
    x: 266,
    y: 266,
    width: 969,
    height: 969,
    result: "image",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iOTY5IiBoZWlnaHQ9Ijk2OSIgdmlld0JveD0iMCAwIDk2OSA5NjkiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6IHVybCgjbGluZWFyLWdyYWRpZW50KTsKICAgICAgfQogICAgPC9zdHlsZT4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50IiB4MT0iNDg0LjUiIHkxPSI5NjkiIHgyPSI0ODQuNSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICA8c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiM4YTAwMjQiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIwLjM2NCIgc3RvcC1jb2xvcj0iIzhhMDAyNCIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9InJlZCIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+CiAgPHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iOTY5IiBoZWlnaHQ9Ijk2OSIvPgo8L3N2Zz4K"
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2",
    x: 9,
    y: 465,
    width: 1026,
    height: 1026,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 20.667,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite"
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodColor: "#8a0024",
    floodOpacity: 0.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite-4",
    operator: "in",
    in2: "composite-3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    mode: "screen",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend-2",
    in: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 23.333,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood-2",
    floodColor: "#fff",
    floodOpacity: 0.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite-6",
    operator: "out",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite-5",
    operator: "in",
    in2: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend-3",
    mode: "screen",
    in2: "blend-2"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "url(#linear-gradient)",
      filter: "url(#filter)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle-2",
    className: "cls-1",
    cx: 750.5,
    cy: 750.5,
    r: 484.5,
    style: {
      stroke: "inherit",
      filter: "none",
      fill: "inherit"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#circle-2",
    style: {
      stroke: "#000",
      filter: "none",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      filter: "url(#filter-2)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle",
    className: "cls-2",
    cx: 522,
    cy: 978,
    r: 447,
    style: {
      stroke: "inherit",
      filter: "none",
      fill: "inherit"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#circle",
    style: {
      stroke: "#505050",
      filter: "none",
      fill: "none"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/appIcon.a9ad7f2d74115878f58370762d9ca76e.svg";
export { ForwardRef as ReactComponent };